import { initials, colorFor } from "./helpers";
import { usePhotoUrl } from "../context/PhotoContext";

export function PlayerAvatar({ id, name, size = 36, ring = true }) {
  const c = colorFor(id || name);
  const photoUrl = usePhotoUrl(id);
  const shadow = ring ? `0 0 0 2px #0b1120, 0 0 0 3px ${c}55` : "none";

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className="inline-block object-cover shrink-0 select-none"
        style={{ width: size, height: size, borderRadius: "50%", boxShadow: shadow }}
      />
    );
  }

  return (
    <span
      className="inline-flex items-center justify-center font-display font-bold shrink-0 select-none"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: `linear-gradient(135deg, ${c}, ${c}cc)`,
        color: "#04120b",
        fontSize: size * 0.4,
        boxShadow: shadow,
      }}
    >
      {initials(name)}
    </span>
  );
}
